/**
 * Colors used for the pieces of the pie chart
 */
export const pieChartColors = [
  ['#fff', '#e30613'],
  ['#4a4a4a', '#e3061333'],
  ['#fff', '#878787'],
  ['#fff', '#4a4a4a'],
  ['#4a4a4a', '#e7e7e7']
];

/**
 * Answer submission delay, in milliseconds
 */
export const submitAnswerDelay = 1000;
